import { ChangeDetectionStrategy, Component } from '@angular/core'
import { RecoveryPointAttemptDto } from 'src/app/services/dtos'
import {
  CHART_SCENARIOS,
  ChartScenarioKey,
  buildMockChartData,
  getMockChartRpo,
} from '../../mocks/showcase-chart-mocks'

/** RPO chart scenarios — drives the rpo-chart input through every empty/populated state. */
@Component({
  selector: 'showcase-chart',
  templateUrl: './showcase-chart.component.html',
  styleUrls: ['./showcase-chart.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ShowcaseChartComponent {
  readonly chartScenarios = CHART_SCENARIOS
  chartScenario: ChartScenarioKey = 'healthy'
  chartData: RecoveryPointAttemptDto[] | null = buildMockChartData('healthy')
  // RPO target (seconds) — most scenarios use 5 min; real-time uses 0 to flip the
  // chart into replication-latency rendering.
  chartRpoSeconds: number = getMockChartRpo('healthy')

  setChartScenario(key: ChartScenarioKey): void {
    if (this.chartScenario === key) return
    this.chartScenario = key
    this.chartData = buildMockChartData(key)
    this.chartRpoSeconds = getMockChartRpo(key)
  }
}
